import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger, SplitText);

const pageScripts = {
  init: function () {
    $.easing.jswing = $.easing.swing;

    $.extend($.easing, {
      def: 'easeOutQuad',
      swing: function (x, t, b, c, d) {
        //alert($.easing.default);
        return $.easing[$.easing.def](x, t, b, c, d);
      },
      easeInQuad: function (x, t, b, c, d) {
        return c * (t /= d) * t + b;
      },
      easeOutQuad: function (x, t, b, c, d) {
        return -c * (t /= d) * (t - 2) + b;
      },
      easeInOutQuad: function (x, t, b, c, d) {
        if ((t /= d / 2) < 1) return (c / 2) * t * t + b;
        return (-c / 2) * (--t * (t - 2) - 1) + b;
      },
      easeInCubic: function (x, t, b, c, d) {
        return c * (t /= d) * t * t + b;
      },
      easeOutCubic: function (x, t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
      },
      easeInOutCubic: function (x, t, b, c, d) {
        if ((t /= d / 2) < 1) return (c / 2) * t * t * t + b;
        return (c / 2) * ((t -= 2) * t * t + 2) + b;
      },
      easeInQuart: function (x, t, b, c, d) {
        return c * (t /= d) * t * t * t + b;
      },
      easeOutQuart: function (x, t, b, c, d) {
        return -c * ((t = t / d - 1) * t * t * t - 1) + b;
      },
      easeInOutQuart: function (x, t, b, c, d) {
        if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b;
        return (-c / 2) * ((t -= 2) * t * t * t - 2) + b;
      },
      easeInQuint: function (x, t, b, c, d) {
        return c * (t /= d) * t * t * t * t + b;
      },
      easeOutQuint: function (x, t, b, c, d) {
        return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
      },
      easeInOutQuint: function (x, t, b, c, d) {
        if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t * t + b;
        return (c / 2) * ((t -= 2) * t * t * t * t + 2) + b;
      },
      easeInSine: function (x, t, b, c, d) {
        return -c * Math.cos((t / d) * (Math.PI / 2)) + c + b;
      },
      easeOutSine: function (x, t, b, c, d) {
        return c * Math.sin((t / d) * (Math.PI / 2)) + b;
      },
      easeInOutSine: function (x, t, b, c, d) {
        return (-c / 2) * (Math.cos((Math.PI * t) / d) - 1) + b;
      },
      easeInExpo: function (x, t, b, c, d) {
        return t == 0 ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
      },
      easeOutExpo: function (x, t, b, c, d) {
        return t == d ? b + c : c * (-Math.pow(2, (-10 * t) / d) + 1) + b;
      },
      easeInOutExpo: function (x, t, b, c, d) {
        if (t == 0) return b;
        if (t == d) return b + c;
        if ((t /= d / 2) < 1) return (c / 2) * Math.pow(2, 10 * (t - 1)) + b;
        return (c / 2) * (-Math.pow(2, -10 * --t) + 2) + b;
      },
      easeInCirc: function (x, t, b, c, d) {
        return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
      },
      easeOutCirc: function (x, t, b, c, d) {
        return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
      },
      easeInOutCirc: function (x, t, b, c, d) {
        if ((t /= d / 2) < 1) return (-c / 2) * (Math.sqrt(1 - t * t) - 1) + b;
        return (c / 2) * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
      },
      easeInElastic: function (x, t, b, c, d) {
        var s = 1.70158;
        var p = 0;
        var a = c;
        if (t == 0) return b;
        if ((t /= d) == 1) return b + c;
        if (!p) p = d * 0.3;
        if (a < Math.abs(c)) {
          a = c;
          var s = p / 4;
        } else var s = (p / (2 * Math.PI)) * Math.asin(c / a);
        return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin(((t * d - s) * (2 * Math.PI)) / p)) + b;
      },
      easeOutElastic: function (x, t, b, c, d) {
        var s = 1.70158;
        var p = 0;
        var a = c;
        if (t == 0) return b;
        if ((t /= d) == 1) return b + c;
        if (!p) p = d * 0.3;
        if (a < Math.abs(c)) {
          a = c;
          var s = p / 4;
        } else var s = (p / (2 * Math.PI)) * Math.asin(c / a);
        return a * Math.pow(2, -10 * t) * Math.sin(((t * d - s) * (2 * Math.PI)) / p) + c + b;
      },
      easeInOutElastic: function (x, t, b, c, d) {
        var s = 1.70158;
        var p = 0;
        var a = c;
        if (t == 0) return b;
        if ((t /= d / 2) == 2) return b + c;
        if (!p) p = d * (0.3 * 1.5);
        if (a < Math.abs(c)) {
          a = c;
          var s = p / 4;
        } else var s = (p / (2 * Math.PI)) * Math.asin(c / a);
        if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin(((t * d - s) * (2 * Math.PI)) / p)) + b;
        return a * Math.pow(2, -10 * (t -= 1)) * Math.sin(((t * d - s) * (2 * Math.PI)) / p) * 0.5 + c + b;
      },
      easeInBack: function (x, t, b, c, d, s) {
        if (s == undefined) s = 1.70158;
        return c * (t /= d) * t * ((s + 1) * t - s) + b;
      },
      easeOutBack: function (x, t, b, c, d, s) {
        if (s == undefined) s = 1.70158;
        return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
      },
      easeInOutBack: function (x, t, b, c, d, s) {
        if (s == undefined) s = 1.70158;
        if ((t /= d / 2) < 1) return (c / 2) * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
        return (c / 2) * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
      },
      easeInBounce: function (x, t, b, c, d) {
        return c - $.easing.easeOutBounce(x, d - t, 0, c, d) + b;
      },
      easeOutBounce: function (x, t, b, c, d) {
        if ((t /= d) < 1 / 2.75) {
          return c * (7.5625 * t * t) + b;
        } else if (t < 2 / 2.75) {
          return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
        } else if (t < 2.5 / 2.75) {
          return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
        } else {
          return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
        }
      },
      easeInOutBounce: function (x, t, b, c, d) {
        if (t < d / 2) return $.easing.easeInBounce(x, t * 2, 0, c, d) * 0.5 + b;
        return $.easing.easeOutBounce(x, t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
      },
    });

    $(window).on('load', function () {
      console.log('Window loaded');
      $('body').addClass('is-loaded');
    });

    // Mobile menu toggle
    $('.js-menuToggle').on('click', function () {
      var me = $(this);
      if (!me.hasClass('active')) {
        $('.header__nav').addClass('opn');
        me.addClass('active');
        $('body').css({ overflow: 'hidden' });
        $('.header').addClass('active');
      } else {
        $('.header__nav').removeClass('opn');
        me.removeClass('active');
        $('body').css({ overflow: 'visible' });
        $('.header').removeClass('active');
      }
    });
    // Mobile submenu toggle

    $('.js-hasSubmenu').prepend("<span class='mob-toggle'></span>");

    $('.js-hasSubmenu .mob-toggle').on('click', function (e) {
      // e.preventDefault();
      var me = $(this);
      var parent = me.closest('.js-hasSubmenu');

      $('.header__sub-nav-wrap').slideUp();
      $('.js-hasSubmenu').removeClass('opn');
      if (!parent.find('.header__sub-nav-wrap').is(':visible')) {
        parent.find('.header__sub-nav-wrap').slideDown();
        $('.js-hasSubmenu, .my__account__mobile').addClass('inactive');
        parent.addClass('opn').removeClass('inactive');
      } else {
        parent.find('.header__sub-nav-wrap').slideUp();
        parent.removeClass('opn');
        $('.js-hasSubmenu, .my__account__mobile').removeClass('inactive');
      }
    });

    // Footer toggle on mobile
    $('.footer .link-sec h4').on('click', function () {
      var me = $(this);
      var parent = me.closest('.link-sec');

      $('.footer .link-sec .link-hold').slideUp();
      $('.footer .link-sec h4').removeClass('opn');
      if (!parent.find('.link-hold').is(':visible')) {
        parent.find('.link-hold').slideDown();
        me.addClass('opn');
      } else {
        parent.find('.link-hold').slideUp();
        me.removeClass('opn');
      }
    });
    // Search toggle
    $('.js-search').on('click', function () {
      if (!$('.header__search-bar').hasClass('active')) {
        $('.header__search-bar').addClass('active');
      } else {
        $('.header__search-bar').removeClass('active');
      }
    });
    $('.js-searchClose').on('click', function () {
      $('.header__search-bar').removeClass('active');
    });

    // Target the element
    let spotlightAnim = document.querySelector('.js-spotlightAnim');

    // Check if the element exists to avoid errors
    if (spotlightAnim) {
      // Splitting the text into words and characters using SplitText
      let split = new SplitText(spotlightAnim, { type: 'words,chars' });
      let chars = split.chars; // Array of all characters

      // GSAP animation
      gsap.from(chars, {
        delay: 0.5, // start the animation 0.5 seconds after page load
        duration: 1, // animation duration of 1 second
        y: -30, // start from 30 pixels above the final position
        opacity: 0, // start fully transparent
        stagger: 0.02, // each character starts slightly after the previous one
        force3D: true, // improves performance by using 3D transforms
        ease: 'power2.out', // easing function for a more natural effect
        onComplete: function () {
          //console.log('done');
          split.revert(); // Optional: revert split to clean up the DOM (remove if you want to split again later)
        },
      });
    }

    // // Spotlight Title animation
    // var str = $('.js-spotlightAnim').text();
    // var splitted = str.split(' ');
    // $('.js-spotlightAnim').empty();
    // $.each(splitted, function(index, val) {
    //   $('.js-spotlightAnim').append($('<span>').text(val));
    // });
    // $('.js-spotlightAnim span').each(function() {
    //   var me = $(this);
    //   var str1 = me.text();
    //   var splitted1 = str1.split('');
    //   me.empty();
    //   $.each(splitted1, function(index, val) {
    //     // console.log(val);
    //     me.append($('<em>').text(val));
    //   });
    // });
    // $(document).ready(function() {
    //   if ($(this).find('.js-spotlightAnim span em').length > 0) {
    //     gsap.from('.js-spotlightAnim span em', { delay: 0.5, duration: 1, y: -30, alpha: 0, stagger: 0.02, force3D: true });
    //   }
    // });

    // Sliders
    // $('.js-product-sliderHome1').slick({
    //   //home slider 1
    //   infinite: true,
    //   slidesToShow: 3,
    //   slidesToScroll: 1,
    //   autoplay: true,
    //   responsive: [
    //     {
    //       breakpoint: 1199,
    //       settings: {
    //         infinite: false,
    //         slidesToShow: 3,
    //       },
    //     },
    //     {
    //       breakpoint: 991,
    //       settings: {
    //         infinite: false,
    //         slidesToShow: 2,
    //       },
    //     },
    //     {
    //       breakpoint: 768,
    //       settings: {
    //         infinite: false,
    //         slidesToShow: 1,
    //       },
    //     },
    //   ],
    // });

    // $('.js-product-sliderHome1').on('afterChange', function(event, slick, currentSlide, nextSlide) {
    //   let addToCart = document.querySelectorAll('.c7-product__variant__add-to-cart');
    //   let quantityLabelEl = `<p class="ada-label">Quantity</p>`;
    //   [...addToCart].forEach((e) => {
    //     e.querySelector('label').ariaLabel = 'quantity';
    //     e.querySelector('label').insertAdjacentHTML('beforeend', quantityLabelEl);
    //   });

    //   let slideItem = document.querySelectorAll('.js-feedSlider .feed-item');

    //   [...slideItem].forEach((e) => {
    //     e.removeAttribute('aria-describedby');
    //   });
    // });

    $('.slider-sec1').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '20vw',
      speed: '1000',
      autoplay: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            centerMode: false,
          },
        },
      ],
    });

    $('.js-tastingSlider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: '1000',
      autoplay: true,
    });

    $('.js-quote-sec--slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: '1000',
      autoplay: true,
    });

    // accordion

    $('.accordion__content:not(:first)').css('display', 'none');
    // $(".js-accordion__title:first-of-type").addClass("js-accordion--open");

    $('.js-accordion__title').click(function () {
      $('.js-accordion--open').not(this).removeClass('js-accordion--open').next().slideUp(300);
      $(this).toggleClass('js-accordion--open').next().slideToggle(300);
    });

    // select2

    $('.contact-form .gfield_select, .js-select2').select2({
      minimumResultsForSearch: -1,
      placeholder: $(this).data('placeholder'),
    });

    // scroll to section

    $('.spotlight__arrow').on('click', function (e) {
      e.preventDefault();
      var element = $('.spotlight__arrow');
      $('html, body').animate(
        {
          scrollTop: $($(this)).offset().top + element.outerHeight(),
        },
        1500,
        'easeInOutExpo'
      );
    });

    // event slider
    // if (window.matchMedia("(max-width: 991px)").matches) {
    //     $(".event-list__wrap").slick({
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //     });
    // }

    $('.event-list__wrap').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 990,
          settings: 'unslick',
        },
      ],
    });
    $(window).on('resize orientationChange', function () {
      var windowWidth = $(window).width();
      if (windowWidth < 990) {
        if (!$('.event-list__wrap').hasClass('slick-initialized')) {
          $('.event-list__wrap').slick('reinit');
        }
      }
    });

    $('.js-testmonial-slider').slick({
      //community testimonial slider
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    $('.js-event-sliderExperience').slick({
      //Experience event slider
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      // autoplay: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    //reservation spotlight mobile
    $('.js-reservationSliderMob').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 767,
          settings: 'unslick',
        },
      ],
    });
    $(window).on('resize orientationChange', function () {
      var windowWidth = $(window).width();
      if (windowWidth < 768) {
        if (!$('.js-reservationSliderMob').hasClass('slick-initialized')) {
          $('.js-reservationSliderMob').slick('reinit');
        }
      }
    });

    //FeedSlider Mob
    $('#feedSlider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '110px',
      mobileFirst: true,
      autoplay: true,
      responsive: [
        {
          breakpoint: 767,
          settings: 'unslick',
        },
      ],
    });
    $(window).on('resize orientationChange', function () {
      var windowWidth = $(window).width();
      if (windowWidth < 768) {
        if (!$('#feedSlider').hasClass('slick-initialized')) {
          $('#feedSlider').slick('reinit');
        }
      }
    });

    // Feed Parallax animation
    if ($('.js-feedSlider').length == 1) {
      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: $('.js-feedSlider'),
          start: 'top center',
          scrub: true,
        },
      });
      tl.to($('.js-feedSlider'), { x: '-8%' });
    }

    // Background parallax animation
    if ($('.background-sec__wrap, .background-sec__wrap--our-story').length == 1) {
      var tl1 = gsap.timeline({
        scrollTrigger: {
          trigger: $('.background-sec__wrap, .background-sec__wrap--our-story'),
          endTrigger: $('.background-sec__wrap, .background-sec__wrap--our-story'),
          // start: 'top bottom',
          end: 'bottom center',
          scrub: true,
        },
      });
      tl1.set($('.background-sec__wrap, .background-sec__wrap--our-story'), { width: '80%' }).to($('.background-sec__wrap, .background-sec__wrap--our-story'), { width: '100%' });
    }

    // Parallax animation
    var elm = $('.js-animTrigger');

    elm.each(function () {
      // title parallax
      if ($(this).find('.js-parallax-title').length > 0) {
        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: $(this),
            endTrigger: $(this),
            // markers: true,
            scrub: true,
          },
        });
        tl.to($(this).find('.js-parallax-title'), { y: 80 });
      }

      // images slight-up parallax
      if ($(this).find('.js-parallax-up').length > 0) {
        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: $(this),
            endTrigger: $(this),
            // markers: true,
            scrub: true,
          },
        });
        tl.to($(this).find('.js-parallax-up'), { y: -150 });
      }
    });

    // Product list parallax
    if ($('.js-parallax-slight-up').length > 0) {
      var elm = $('.js-parallax-slight-up');

      elm.each(function () {
        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: $(this),
            endTrigger: $(this),
            start: 'center bottom',
            // markers: true,
            scrub: true,
          },
        });
        tl.to($(this), { y: -50 });
      });
    }
    if ($('.shop-gift-offerings__wrap').length > 0) {
      var elm = $('.shop-gift-offerings__item:odd');

      elm.each(function () {
        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: $(this),
            endTrigger: $(this),
            start: 'top bottom',
            // markers: true,
            scrub: true,
          },
        });
        tl.to($(this), { y: 100 });
      });
    }

    // Product details page parallax
    if ($('.product-details-accolade__wrap').length > 0) {
      if ($('.accolade-item').length > 2) {
        var elm = $('.accolade-item:odd');

        elm.each(function () {
          var tl = gsap.timeline({
            scrollTrigger: {
              trigger: $(this),
              endTrigger: $(this),
              start: 'top bottom',
              // markers: true,
              scrub: true,
            },
          });
          tl.to($(this), { y: -100 });
        });
      }
    }
    // if ($('.review-sec__wrapper').length > 0) {
    //   var elm = $('.review-sec__item:even');

    //   elm.each(function() {
    //     var tl = gsap.timeline({
    //       scrollTrigger: {
    //         trigger: $(this),
    //         endTrigger: $(this),
    //         start: 'top bottom',
    //         // markers: true,
    //         scrub: true,
    //       },
    //     });
    //     tl.to($(this), { y: -100 });
    //   });
    // }

    // Community page parallax
    if ($('.community-recipes-sec').length > 0) {
      var elm = $('.recipes-title-block');

      elm.each(function () {
        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: $(this),
            endTrigger: $(this),
            start: 'top bottom',
            // markers: true,
            scrub: true,
          },
        });
        tl.to($(this), { y: -120 });
      });
    }
    if ($('.overlaping-2-col').length > 0) {
      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: $('.overlaping-right-sec'),
          endTrigger: $('.overlaping-right-sec'),
          start: 'top bottom',
          // markers: true,
          scrub: true,
        },
      });
      tl.from($('.overlaping-right-sec'), { y: 100 });
    }

    // Scroll to section
    $('.js-scrollToSection').on('click', function (e) {
      e.preventDefault();
      var id = $(this).attr('href');
      if ($(id).length > 0) {
        $('html, body').animate(
          {
            scrollTop: $(id).offset().top,
          },
          1000
        );
      }
    });

    // tab-slider
    $('.js-tabSliderPane').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.js-tabSliderNav',
      // fade: true,
      infinite: true,
      speed: 1000,
    });

    $('.js-tabSliderNav').slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.js-tabSliderPane',
      arrows: false,
      dots: false,
      centerMode: true,
      focusOnSelect: true,
      variableWidth: true,
      speed: 700,
    });

    var tabsliderNavLenght = $('.js-tabSliderNav .tab-nav__item').length;

    $('.js-tabSliderPane').on('afterChange', function (event, slick, currentSlide) {
      // console.log(slick, currentSlide);
      if (slick.$slides.length - 1 == currentSlide) {
        $('.js-tabSliderNav').slick('slickGoTo', tabsliderNavLenght - 1);
      }
      if (currentSlide == 0) {
        $('.js-tabSliderNav').slick('slickGoTo', 0);
      }
    });

    // Tab-Sync-slider Mobile accordion
    $('.details-shipment .title').on('click', function () {
      var me = $(this);
      var parent = me.closest('.details-item');

      if (!parent.find('.details-item-copy').is(':visible')) {
        $('.details-shipment .details-item').removeClass('opn');
        $('.details-shipment .details-item-copy').slideUp();

        parent.addClass('opn');
        parent.find('.details-item-copy').slideDown();
      } else {
        parent.removeClass('opn');
        parent.find('.details-item-copy').slideUp();
      }
    });

    // Locations Banner nav sticky
    $(window).on('load', function () {
      if ($('.spotlight-locations__nav').length > 0) {
        var boxInitialTop = $('.spotlight-locations__nav').offset().top;
        $(window).scroll(function () {
          // console.log($(window).scrollTop() +  ' - ' + boxInitialTop);
          if ($(window).scrollTop() > boxInitialTop) {
            // Box's some portion or all if it have gone up the scroll view area
            $('.spotlight-locations').addClass('nav-sticky');
          } else {
            $('.spotlight-locations').removeClass('nav-sticky');
          }
        });
      }
    });

    // Show More Show less
    $('.js-viewMore').on('click', function () {
      var parent = $(this).closest('blockquote');
      parent.find('.small-txt').slideUp();
      parent.find('.full-txt').slideDown();
    });
    $('.js-viewLess').on('click', function () {
      var parent = $(this).closest('blockquote');
      parent.find('.full-txt').slideUp();
      parent.find('.small-txt').slideDown();
    });
  },
};

export default pageScripts;
